import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { Language } from "redux/actions";

const PageBreadcrumbs = ({ breadCrumbs }) => {
    const dispatch = useDispatch();
    const { pageBreadCrumb } = useSelector((state) => state.LanguageSlice);
    const { t } = useTranslation();
    useEffect(() => {
        return () => {
            dispatch(Language.setPageBreadCrumb([]))
        }
    }, [])
    if(breadCrumbs?.length <= 0) {
        return null;
    }
    let child = breadCrumbs?.slice(1);
    let parent = breadCrumbs?.[0];
    if(pageBreadCrumb?.length > 0) {
        parent = pageBreadCrumb?.[0];
        child = pageBreadCrumb?.slice(1);
    }


    return (
        <>
            <style>
                {`
          .custom-class ol{
            align-items:baseline
          }
        `}
            </style>
            <Breadcrumb className="custom-class" style={{}}>
                <Breadcrumb.Item
                    className="text-24px font-semibold"
                    href={parent?.href ?? null}
                    onClick={()=>{
                        parent?.onClick()
                    }}
                >
                    {t(parent?.label)}
                </Breadcrumb.Item>
                {child?.map(({ href, label , onClick=()=>{} }, index) =>  (
                    <Breadcrumb.Item key={index} href={href ?? null} onClick={onClick}>{t(label)}</Breadcrumb.Item>
                ))} 
            </Breadcrumb>
        </>
    );
};

export default PageBreadcrumbs;
